<script>
export default {
  data: () => ({
    icons: [
      { url: 'https://www.twitter.com/BotInventory', icon: 'mdi-twitter' },
    ],
    currentYear: new Date().getFullYear(),
  }),
}
</script>

<template>
  <v-footer dark padless width="100%" :class="$style.siteFooter">
    <v-card
      flat
      tile
      class="indigo lighten-1 white--text text-center"
      width="100%"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon.icon"
          class="mx-4 white--text"
          icon
        >
          <a :href="icon.url" :class="$style.iconLink" target="_blank"
            ><v-icon size="24px">
              {{ icon.icon }}
            </v-icon></a
          >
        </v-btn>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        <strong> Copyright &#169; {{ currentYear }} - Inventory Bot Co.</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style lang="scss" module>
@import '@design';

a.iconLink {
  color: white !important;
  text-decoration: none;
}

.siteFooter {
  margin-top: 40px;
}
</style>
